export const circInOut = {
    ease: [0.86, 0, 0.07, 1],
    duration: 0.5,
};
